export const MCU_STATUS = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    REQUESTED: 'REQUESTED',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
    ARRIVED: 'ARRIVED',
    DEPARTED: 'DEPARTED',
    CANCELLED: 'CANCELLED',
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    TRANSFER: 'TRANSFER',
};

export const ACCEPTED_MCU_STATUSES = [MCU_STATUS.ACCEPTED, MCU_STATUS.ARRIVED, MCU_STATUS.DEPARTED];

export const INCIDENT_STATUS = {
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    OPEN: 'OPEN',
    TRANSFER_PENDING: 'TRANSFER_PENDING',
    CLOSED: 'CLOSED',
    WAITLISTED: 'WAITLISTED',
};

export const REFERRAL_STATUS = {
    COMPLETED: 'Completed - Referral',
};

export const TABS = {
    PROFILE: 'PROFILE',
    MOBILE_UNIT: 'MOBILE_UNIT',
};

export const COMMON_DECLINE_CANCEL_REASON = {
    OTHER: 'OTHER',
};

export const COMMON_DECLINE_CANCEL_REASON_DROPDOWN = {
    [COMMON_DECLINE_CANCEL_REASON.OTHER]: 'other',
};

export const DECLINE_REASON_ERRORS = {
    REASON: 'Please select a reason for decline.',
    DESCRIPTION: 'Please enter decline reason.',
};

export const CANCEL_REQUEST_REASON_ERRORS = {
    REASON: 'Please select a reason for canceling.',
    DESCRIPTION: 'Please enter cancel reason.',
};

export const RESPONSE_FORM_ERRORS = {
    DISPOSITION: 'A disposition must be selected',
    EARLY_DEPARTED_TIME: 'Departed time cannot be before the Arrived time',
    FOLLOW_UP_MISSING_FIELDS: 'The follow up section is missing required fields.',
    INVALID_DEPARTED_TIME: 'Invalid Time',
    NOTES: 'Please enter notes for a disposition of "Other"',
    TRANSPORTATION_MISSING_FIELDS: 'Transportation section is missing required fields.',
    TRANSPORTATION_TYPE: 'Transport method is required',
    TRANSPORT_LOCATION: 'Transport location is required',
    ABUSE_REPORT_MADE: 'This is required if Type of Abuse is selected',
    ABUSE_ASSIST_CALLER: 'This is required if Type of Abuse is selected',
};

export const TRANSPORTATION_MESSAGES = {
    TRANSPORTATION_NEEDED: 'Transportation Needed',
    TRANSPORTATION_TYPE: 'Transport Method',
    TRANSPORTATION_LOCATION: 'Transport Location',
    SELECT_PLACEHOLDER: 'Make a Selection',
};

export const RESPONSE_FORM_NAME = 'ResponseForm';
